import React from "react";

import { MyPortfolioIndividual } from "./SubMyPortfolio";
import Portfolio from './SubMyPortfolio/AlienPortfolioIndividual';

export default (props) => {

    const {pageData, alien} = props;

    return (
        <div className="menu-content-profile menu-content-item tab-parent screen-bottom-block">
            <div className="rounded-white-block">

                <div className="white-block-content">
                    {
                        alien
                        ? <Portfolio {...pageData}/>
                        : <MyPortfolioIndividual {...pageData} />
                    }
                </div>

            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Profile/MyProfile.js